<script lang="ts">
  import Alert from '../Alert.svelte';
  import type { IHero } from './Hero.svelte';

  export let hero: IHero;
</script>

<Alert severity="notice">
  Tipo de sección no soportada `{hero.type}`
</Alert>
